export default (axios) => axios.get('/project/meta');
